var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFactoringMenu = function SvgFactoringMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#factoring-menu_svg__a)",
    fillRule: "evenodd",
    d: "M3.829 0C2.819 0 2 .819 2 1.829V22.17C2 23.181 2.819 24 3.829 24H19.37c1.01 0 1.829-.819 1.829-1.829V1.83C21.2.819 20.381 0 19.371 0zm7.2 7.631q.535.368 1.33.367c.275 0 .532-.04.778-.128q.368-.125.558-.276l-.115-.777a2.7 2.7 0 0 1-.566.239q-.302.088-.626.087c-.529 0-.92-.171-1.177-.521a1.8 1.8 0 0 1-.264-.523h2v-.6h-2.114a4 4 0 0 1-.007-.4h2.122v-.6h-2.036q.101-.378.318-.644.404-.494 1.177-.494c.208 0 .413.026.603.08q.29.081.559.222l.134-.851a2.739 2.739 0 0 0-1.278-.313q-.849-.001-1.4.367-.553.366-.816.996-.124.3-.19.637H8.95v.6h1.003a5 5 0 0 0 .002.4H8.948v.6h1.087q.065.286.181.55.275.615.813.982",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "factoring-menu_svg__a",
    x1: 11.62,
    x2: 11.62,
    y1: 0,
    y2: 23.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7CC6",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A00"
  })))));
};
export default SvgFactoringMenu;